const map_markers = [];
const infowindow = new google.maps.InfoWindow({minWidth: 150});
let map_active = false;

const userActivities = {
    'Alex Porter': {said: 'At the gym', actual: '**Privacy Deluxe Package Enabled**'},
    'Oliver Blackshire': {said: 'Late to work', actual: '8th time this month'},
    'Freddy Essex': {said: 'Out with a pal', actual: '(RoboGirl)'},
    'Laura Barnes': {said: 'Having wine', actual: 'Spilled it down herself'},
    'Valia Brady': {said: 'Has plans', actual: 'Fighting a VR dragon'},
    'Danny Kalfa': {said: 'Working overtime', actual: 'At a rave with 2 other friends'},
    'Andy Sturrock': {said: 'Trading cryptocurrency', actual: 'Currently down $400'},
    'Mark Kennan': {said: 'Babysitting', actual: 'Drinking with 3 other friends'},
}


const init_map = () =>
{
    build_map();

    map_active = true;
}


const build_map = () =>
{

    const map_canvas = document.getElementById('js-social-map');

    const user_pos = {
        lat: user.locations.user.lat,
        lng: user.locations.user.lng
    };

    const map = new google.maps.Map(map_canvas,
        {
            center: user_pos,
            zoom: 15,
            minZoom: 10,
            maxZoom: 15,
            disableDefaultUI: true,
            restriction: {latLngBounds: {north: 83.8, south: -57, west: -180, east: 180}},
            styles: map_styles
        });

    add_map_markers(map, map_markers);
    check_if_map_is_loaded(map);
}


const add_map_markers = (map, map_markers) =>
{
    add_user_marker(map);
    add_friend_markers(map);
    create_marker_cluster(map, map_markers);
}

const create_marker = (map, lat, lng, icon_path, name) =>
{
    const marker = new google.maps.Marker(
        {
            position:
                {
                    lat: lat,
                    lng: lng,
                },
            icon: map_icon_options(icon_path),
            name: name
        });

    marker.setMap(map);
    map_markers.push(marker);
    bind_listener_to_marker(map, marker);
}


const map_icon_options = (icon_path) =>
{
    return {
        url: icon_path,
        scaledSize: new google.maps.Size(15, 15),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(0, 0)
    };
}


const animate_user_icon = (marker, animation) =>
{
    marker.setAnimation(google.maps.Animation[animation]);
}


const add_user_marker = (map) =>
{
    create_marker(map, user.locations.user.lat, user.locations.user.lng, './assets/img/map-marker-user.svg', user.name);
    animate_user_icon(map_markers[0], 'BOUNCE');
}


const add_friend_markers = (map) =>
{
    for (const friend of user.locations.friends)
    {
        create_marker(map, friend.lat, friend.lng, './assets/img/map-marker-friends.svg', friend.name)
    }
}


const create_marker_cluster = (map, markers) =>
{
    const markerCluster = new MarkerClusterer(map, markers, {
        styles: mapcluster_icon_options(),
        maxZoom: 12,
        gridSize: 50
    });

    bind_marker_cluster_event(markerCluster);
}


const mapcluster_icon_options = () =>
{
    return [
        {
            url: './assets/img/map-cluster-icon.svg',
            height: 31,
            width: 50,
        }];
}

const check_if_map_is_loaded = (map) =>
{
    google.maps.event.addListenerOnce(map, 'tilesloaded', update_map_container_classes);

    function update_map_container_classes()
    {
        cached_elements.remove_class('#js-social-map-container', 'loading');
        cached_elements.add_class('#js-social-map-container', 'loaded');
    }
}


const bind_marker_cluster_event = (markerCluster) =>
{
    google.maps.event.addListener(markerCluster, 'clusteringend', function ()
    {
        const markers = this.markers_;

        for (const marker of markers)
        {
            if (marker === map_markers[0] && !marker.animation)
            {
                animate_user_icon(marker, 'BOUNCE');
            }
        }
    });
}


const bind_listener_to_marker = (map, marker) =>
{
    if (marker !== map_markers[0])
    {
        // let activityActual = ;


        marker.addListener('mouseover', function ()
        {
            let privacyDeluxe = (marker.name === 'Alex Porter') ? 'privacy-deluxe' : '';
            infowindow.setContent(`<div class="social__map-popup">
                                <h6><b>${marker.name}</b> - <span>${userActivities[marker.name]['said']}</span></h6>
                                <p class="${privacyDeluxe}">${userActivities[marker.name]['actual']}</p>
                                </div>`);
            infowindow.open(map, marker);
        });
    }
};

const update_map = () =>
{

    // if ( update_location_attemps < 3 )
    // {
    //   watch_id = navigator.geolocation.watchPosition( nav_share_location , () =>
    //   {
    //     navigator.geolocation.clearWatch( watch_id );
    //     console.log('cleared in error')
    //   } );
    // }
    // else
    // {
    //   navigator.geolocation.clearWatch( watch_id );
    //   console.log('cleared in attempts')
    // }
    update_marker_position();
}

const update_marker_position = () =>
{

    if (map_active)
    {
        let new_latlng;
        for (const i in map_markers)
        {
            console.log(i)
            if (i == 0)
            {
                new_latlng = new google.maps.LatLng(user.locations.user.lat, user.locations.user.lng)
            }
            else
            {
                console.log(i - 1)
                new_latlng = new google.maps.LatLng(user.locations.friends[i - 1].lat, user.locations.friends[i - 1].lng)
            }
            map_markers[i].setPosition(new_latlng);
        }
    }

}


const extend_MarkerClusterer_prototype = () =>
{
    MarkerClusterer.prototype.createClusters_ = function ()
    {
        if (!this.ready_)
        {
            return;
        }

        const mapBounds = new google.maps.LatLngBounds(this.map_.getBounds().getSouthWest(),
            this.map_.getBounds().getNorthEast());
        const bounds = this.getExtendedBounds(mapBounds);

        for (let i = 0, marker; marker = this.markers_[i]; i++)
        {
            if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds))
            {
                this.addToClosestCluster_(marker);
            }
        }
        google.maps.event.trigger(this, "clusteringend", this);
    };
}

extend_MarkerClusterer_prototype();